import React, { useEffect, useRef, useState } from "react";
import TeachersList from "./TeachersList"; // Renamed the component here  
import {
  teacher_reviews_profile,
  teacher_reviews_profile_aword,
  search,
  srot
} from "../../assets/images/images";
import { ReactSVG } from "react-svg";
import {
  fetchAllSchoolData,
  resetAllTeacherBySchool,
} from "../../state/actions/getAllTeacherBySchoolAction";
import { useDispatch, useSelector } from "react-redux";
import { useAuth } from "../../features/auth/AuthContext";
import { useLoaderData, useLocation, useNavigate, useParams } from "react-router";
import PaginationView from "../../components/Pagination/PaginationView";
import BackButton from "../../../src/components/BackButton/BackButton";
import TeacherFilter from "./TeacherFilter";
import { addToHistory } from '../../state/reducers/historyReducer';
import { CircularProgress, Grid } from "@mui/material";
import DataTableListing from "../DataTableListing/DataTableListing";
import api from "../../api/api"
import { toast } from "react-toastify";
import search_bar from "../../assets/images/search.svg";
import AddProfilePopup from "../Add Profile/AddProfilePopup";
import EnrollmentResponsiveCards from "../../modules/admin/Dashboard/RecentEnrollment/EnrollmentResponsiveCards";
import SearchComponent from "../SearchComponent/SearchComponent";

const Teachers = () => {
  const { token } = useAuth();
  const [currentPage, setCurrentPage] = useState(1);
  const [searchOption, setsearchOption] = useState("");
  const [sortOption, setSortOption] = useState("");
  const [filterOption, setfilterOption] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const [isVisiblefillter, setIsVisiblefillter] = useState(false);
  const [grade, setgrade] = useState("");
  const [subject, setsubject] = useState("");
  const dispatch = useDispatch();
  const { role } = useSelector((state) => state.globalState);
  const { teachers, students, count, next, previous, totalPages, error, isLoading } = useSelector(
    (state) => state.fetchSchoolData
  );
  const navigate = useNavigate();
  const [statuses, setStatuses] = useState({});
  const sortRef = useRef(null);
  const location = useLocation();
  const filterRef = useRef(null);
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [showAddPopup, setShowAddPopup] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
    
      useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 1024);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
      }, []);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedSearch(searchOption), 400);
    return () => clearTimeout(timer);
  }, [searchOption]);
  // ── Outside click handler ──
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (sortRef.current && !sortRef.current.contains(e.target)) setIsVisible(false);
      if (filterRef.current && !filterRef.current.contains(e.target)) setIsVisiblefillter(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  const filterArray = [
    { id: "Invited", name: "Invited & Enrolled" },
    { id: "Enrolled", name: "Enrolled" },
    { id: "", name: "All" },
  ]

  useEffect(() => {
    setCurrentPage(1);
  }, [searchOption, sortOption, filterOption]);

  useEffect(() => {
    getAllteacherDetails();
    window.scrollTo(0, 0);
    return () => {
      dispatch(resetAllTeacherBySchool());
    };
  }, [currentPage, debouncedSearch, sortOption, filterOption, grade, subject]);

  useEffect(() => {
    dispatch(addToHistory('/dashboard/teachers'))
  }, [])

  useEffect(() => {
    return () => {
      dispatch(resetAllTeacherBySchool());
    };
  }, []); // Unconditionally called at the beginning
  const globalState = useSelector((state) => state.globalState);
  const getAllteacherDetails = () => {
    const type = 'Teacher'; // Define the type variable
    const school_id = globalState.school_id;
    dispatch(fetchAllSchoolData(currentPage, school_id, token, type, role, debouncedSearch, filterOption, sortOption, grade, "", subject));
  };

  const [selectedValue, setSelectedValue] = useState('individual');

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  // This function will render only the text of the selected option
  const renderValue = (selected) => {
    return selected === 'individual' ? 'Individual' : 'Organization';
  };

  const handleSearch = (e) => {
    setsearchOption(e.target.value)
  }

  const handleSortOptionChange = (newSortOption) => {
    setSortOption(newSortOption);
  };

  const handleApplyClick = () => {
    setIsVisible(false);
    setIsVisiblefillter(false)
  }

  // Example array of organizations
  const organizations = [
    { id: 1, name: 'Saddle River Day School' },
    { id: 2, name: 'American International School of Algiers' },
    { id: 3, name: 'Saddle River Day School' },
    { id: 4, name: 'Pine Grove Academy' },
    { id: 5, name: 'Saddle River Day School' },
    { id: 6, name: 'Pine Grove Academy' },
    // Add more organizations here
  ];
const formatDate = (dateStr) => {
  if (!dateStr) return "—";
  const date = new Date(dateStr);
  const day = date.toLocaleString("en-GB", { day: "2-digit" });
  const month = date.toLocaleString("en-GB", { month: "short" });
  const year = date.getFullYear();
  return `${day} ${month}, ${year}`;
};
  const columns = [
  {
    key: "ai_avatar",
    title: "Teacher Name",
    render: (value, row) => (
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        {value ? (
          <img src={value} alt={row.name} style={{ width: 32, height: 32, borderRadius: "50%", objectFit: "cover", flexShrink: 0 }} />
        ) : (
          <div style={{ width: 32, height: 32, borderRadius: "50%", background: "#e2e8f0", flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, color: "#94a3b8", fontWeight: 600 }}>
            {row.name?.charAt(0)}
          </div>
        )}
        <span>{row.name}</span>
      </div>
    ),
  },
  { key: "uid",      title: "Teacher ID",   headerStyle: { textAlign: "center" },
      render: (v) => (
        <div style={{ textAlign: "center" }}>
          {v}
        </div>
      ), },
  { key: "email",    title: "Email",        render: (v) => <span>{v}</span> },
  { key: "subjects", title: "Subjects",     render: (v) => <span>{Object.values(v ?? {}).slice(0, 3).join(", ")}</span> },
  { key: "joined_at", title: "Joining Date", headerStyle: { textAlign: "center" },
      render: (v) => (
        <div style={{ textAlign: "center" }}>
          {formatDate(v)}
        </div>
      ), },
  {
    key: "active",
    title: "Status",
    headerStyle: { textAlign: "center" },
    render: (_, row) => {
      const isActive = statuses[row.teacher_id] ?? row.active;
      return (
        <div
          onClick={() => toggleStatus(row.teacher_id, isActive, row.user_id)}
          style={{ width: 90, height: 30, borderRadius: 999, background: isActive ? "#E0F4FF" : "#f1f5f9", cursor: "pointer", position: "relative", display: "flex", alignItems: "center",justifyContent:"center",  transition: "background 0.25s", flexShrink: 0 }}
        >
          <span style={{ position: "absolute", left: isActive ? 12 : 30, fontSize: 12.5, fontWeight: 500, color: isActive ? "#0068FF" : "#94a3b8", transition: "left 0.25s", userSelect: "none" }}>
            {isActive ? "Active" : "Inactive"}
          </span>
          <div style={{ width: 22, height: 22, borderRadius: "50%", background: "#fff", position: "absolute", ...(isActive ? { right: 4 } : { left: 4 }), boxShadow: "0 1px 4px rgba(0,0,0,0.15)", transition: "all 0.25s" }} />
        </div>
      );
    },
  },
  {
    key: "action",
    title: "Action",
    headerStyle: { textAlign: "center" },
    render: (_, row) => (
      <div style={{ display: "flex", justifyContent: "center" }}>
      <span
        style={{ color: "#0068FF", fontSize: 13.5, fontWeight: 500, cursor: "pointer" }}
        onClick={(e) => { e.stopPropagation(); navigate(`/TeacherProfile/${row.teacher_id}`, { state: { teacher_id: row.teacher_id, from: location.pathname } }); }}
      >
        View Profile
      </span>
      </div>
    ),
  },
];

  const toggleStatus = async (teacher_id, currentStatus, user_id) => {
  setStatuses((prev) => ({
    ...prev,
    [teacher_id]: prev[teacher_id] !== undefined ? !prev[teacher_id] : !currentStatus,
  }));

  try {
    const result = await api.post(
      "super-admin/school/active-deactive/",
      { user_id, active: !currentStatus },
      { headers: { "Content-Type": "application/json", Authorization: `Token ${token}` } }
    );
    if (result.status === 200) {
      toast.success(!currentStatus ? "Teacher account has been enabled." : "Teacher account has been disabled.");
    } else {
      setStatuses((prev) => ({ ...prev, [teacher_id]: currentStatus }));
    }
  } catch (error) {
    setStatuses((prev) => ({ ...prev, [teacher_id]: currentStatus }));
  }
};
const subjectEntries = Object.entries(globalState?.datalist?.top_ten_subjects || {});

  return (
    <>
       {showAddPopup && (
        <AddProfilePopup
            entity="Teacher"
            toggleshowAddProfile={() => {
            setShowAddPopup(false);
            }}
        />
        )}
    
         <BackButton handleClick={() => navigate("/dashboard/home")} buttonName="Back" /> 
     {/* Toolbar */}
      <div className="advisor-toolbar">
        <div className="advsior-left-tools">
          <h3>Teachers</h3>
            {/* Search */}
            <SearchComponent
              search={search_bar}
              searchPlaceholder="Search Teachers"
              value={searchOption}
              onchange={handleSearch}
            />
         {/*  <div className="search-bar">
            <img src={search_bar} alt="search-bar" />
            <div className="search-divider"></div>
            <input
              placeholder="Search Teachers"
              value={searchOption}
              onChange={(e) => setsearchOption(e.target.value)}
            />
          </div> */}
        </div>

        <div className="advisor-right-tools">
          {/* Filter */}
          {/* <div style={{ position: "relative" }} ref={filterRef}>
            <button className="sort-button"
              onClick={() => { setIsVisiblefillter((prev) => !prev); setIsVisible(false); }}
            >
              <i className="fa-solid fa-sliders" style={{ marginRight: 6 }}></i>
              Filter
            </button>
            {isVisiblefillter && (
              <TeacherFilter
                gradeList={globalState?.grade_details?.grade}
                grade={grade}
                setgrade={setgrade}
                subjectList={globalState?.datalist?.top_ten_subjects}
                subject={subject}
                setsubject={setsubject}
                isVisiblefillter={isVisiblefillter}
                handleApplyClick={handleApplyClick}
              />
            )}
          </div> */}

          {/* ── REPLACE TeacherFilter with inline dropdown ── */}
          <div className="flex items-center justify-between gap-2 mt-2 md:mt-0">
            {/* Filter */}
          {/* <div className="relative" ref={filterRef}>
          <button
            className="sort-button"
            onClick={() => { setIsVisiblefillter((prev) => !prev); setIsVisible(false); }}
          >
            <i className="fa-solid fa-sliders mr-1"></i>
            Filter
          </button>

          {isVisiblefillter && (
            <div className="sort-menu min-w-[200px]">
              <div className="px-3 py-2 font-semibold">Subject</div>

              <div
                className="sort-options"
                onClick={() => { setsubject(""); setIsVisiblefillter(false); }}
                style={{ color: !subject ? "#0068FF" : "#374151", fontWeight: !subject ? 600 : 400 }}
              >
                All Subjects
              </div>

              {subjectEntries.map(([id, name]) => (
                <div
                  key={id}
                  className="sort-options"
                  onClick={() => { setsubject(id); setIsVisiblefillter(false); }}
                  style={{
                    color: subject === id ? "#0068FF" : "#374151",
                    fontWeight: subject === id ? 600 : 400,
                    background: subject === id ? "#f0f7ff" : "#fff",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.background = "#f9fafb") }
                  onMouseLeave={(e) =>(e.currentTarget.style.background = subject === id ? "#f0f7ff" : "#fff")}
                >
                  {name}
                </div>
              ))}
            </div>
          )}
        </div> */}

          {/* Sort */}
          <div className="relative" ref={sortRef}>
            <button className="sort-button"
              onClick={() => { setIsVisible((prev) => !prev); setIsVisiblefillter(false); }}
            >
              <img src={srot} alt="sort" />
              Sort
            </button>
            {isVisible && (
              <div className="sort-menu">
                {[
                  { label: "Name : A - Z", value: "A-Z" },
                  { label: "Name : Z - A", value: "Z-A" },
                  { label: "Newest First", value: "Newest" },
                  { label: "Oldest First", value: "Oldest" },
                ].map((option) => (
                  <div className="sort-options"
                    key={option.value}
                    onClick={() => { setSortOption(option.value); setIsVisible(false); }}
                    style={{
                      color: sortOption === option.value ? "#0068FF" : "#374151",
                      fontWeight: sortOption === option.value ? 600 : 400,
                      background: sortOption === option.value ? "#f0f7ff" : "#fff",
                    }}
                    onMouseEnter={(e) =>(e.currentTarget.style.background = "#f9fafb")}
                    onMouseLeave={(e) =>(e.currentTarget.style.background = sortOption === option.value ? "#f0f7ff" : "#fff") }
                  >
                    {option.label}
                  </div>
                ))}
              </div>
            )}
          </div>
          </div>

            <button className="add-advsior-button" onClick={() => setShowAddPopup(true)}>
                 + Add Teacher
            </button>
        </div>
      </div>


        <div style={{ marginTop: 30 }}>
        {isMobile ? (
          <EnrollmentResponsiveCards
            userType={"teacher"}
            data={teachers.map((teacher) => ({
              key: teacher.teacher_id,
              id: teacher.teacher_id,
              user_id: teacher.user_id,
              is_active: teacher.active,
              name: teacher.name,
              profilePic: teacher.ai_avatar,
              email: teacher.email,
              subjects: Object.values(teacher.subjects ?? {})
                .slice(0, 3)
                .join(", "),
              joinDate: formatDate(teacher.joined_at) || "—",
              active: teacher.active,
            }))}
            onToggleStatus={(id, is_active, user_id) =>
              toggleStatus(id, is_active, user_id)
            }
            onCardClick={(item) => navigate(`/TeacherProfile/${item.id}`, {
              state: { teacher_id: item.id, from: location.pathname }
            })}
            statuses={statuses}
            pagination={{
              currentPage,
              total: count ?? 0,
              pageSize: 12,
              onChange: (page) => setCurrentPage(page),
            }}
          />
        ) : (
          <DataTableListing
            columns={columns}
            dataSource={teachers ?? []}
            rowKey="teacher_id"
            pagination={false}
            checkable={false}
            loading={isLoading}
            emptyText="No Teachers Found"
            bordered={false}
            size="default"
            rowHoverColor="#F7F7F7"
          />
        )}
        </div>

      <div className="Select-organization-dropdown-menu-wrapper">
        <div className="Select-organization-dropdown-menu-popup-cross-btn">
          <i class="fa-solid fa-x"></i>
        </div>
        <div className="Select-organization-dropdown-menu-container">
          <BackButton buttonName={"Select organization"} />
          <div className="Select-organization-dropdown-serach">
            <input type="serach" placeholder="Search for organization" />
            <span><i class="fa-solid fa-magnifying-glass"></i></span>
          </div>
          <div className="Select-organization-dropdown-inner-wrapper">
            {organizations.map((org) => (
              <div key={org.id} className="Select-organization-dropdown-inner-folder">
                <input type="checkbox" id={`checkbox-${org.id}`} />
                <label htmlFor={`checkbox-${org.id}`}>{org.name}</label>
              </div>
            ))}
          </div>
          <div className="Select-organization-dropdown-btn">
            <button>Apply</button>
            <button>Clear All</button>
          </div>
        </div>
      </div>
      {totalPages > 1 && (
        <PaginationView
          totalPages={totalPages}
          next={next}
          previous={previous}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      )}
    </>
  );
};

export default Teachers;